import { Button, Space } from 'antd';
import { StarOutlined } from '@ant-design/icons';
import { useTranslate } from '@refinedev/core';
import { useTestimonialActions } from '@/hooks/feedback/useTestimonialActions';

interface TestimonialActionButtonsProps {
  testimonialId?: string | number;
  isPromoted?: boolean;
}

export const TestimonialActionButtons = ({
  testimonialId,
  isPromoted,
}: TestimonialActionButtonsProps) => {
  const t = useTranslate();
  const actions = useTestimonialActions({ testimonialId });

  if (isPromoted) return null;

  return (
    <Space>
      <Button
        type="primary"
        icon={<StarOutlined />}
        onClick={actions.promote.mutate}
        loading={actions.promote.isLoading}
      >
        {t('feedback.testimonials.actions.promote')}
      </Button>
    </Space>
  );
};
